/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import axios from 'axios';
import { batchActions } from 'redux-batched-actions';
// material
import { displayErrorMessage } from '@insticator/insticator-ui';
// utils
import { asyncExportRatingsAnalytics } from 'utils/api/ratings';


/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export const EXPORTING_RATINGS_ANALYTICS = 'EXPORTING_RATINGS_ANALYTICS';
export const EXPORT_RATINGS_ANALYTICS_SUCCESS = 'EXPORT_RATINGS_ANALYTICS_SUCCESS';
export const EXPORT_RATINGS_ANALYTICS_FAILED = 'EXPORT_RATINGS_ANALYTICS_FAILED';

export const exportRatingsAnalytics = ({format, siteUUID}) => dispatch => {
  dispatch(exportingRatingsAnalytics(format, true));
  asyncExportRatingsAnalytics({format, siteUUID})
    .then(response => {
      const exportedFileUrl = response.data.exportedFileUrl;
      axios.get(exportedFileUrl)
        .then(exportedFileResponse => {
          const fileName = exportedFileUrl.split('/').pop();
          const link = document.createElement('a');
          link.download = fileName;
          link.href = `data:application/${format.toLowerCase()};charset=utf-8,` + encodeURIComponent(exportedFileResponse.data);
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          
          setTimeout(() => { dispatch(exportRatingsAnalyticsSuccess(format)) }, 800);
        })
        .catch(error => {
          dispatch(exportRatingsAnalyticsFail(format, 'There was an error downloading the exported file.'));
        })
    }, error => {
      let errorMessage = error.response.status === 404 ? 'No ratings recorded yet to the selected site.' : 'There was an error on exporting the ratings analytics.';
      setTimeout(() => { dispatch(exportRatingsAnalyticsFail(format, errorMessage)) }, 1500);
    });
}

const exportingRatingsAnalytics = (format, status) => ({
  type: EXPORTING_RATINGS_ANALYTICS,
  format,
  status
});

const exportRatingsAnalyticsSuccess = (format) => batchActions([
  exportingRatingsAnalytics(format, null),
  exportRatingsAnalyticsSucceed()
]);

const exportRatingsAnalyticsSucceed = () => ({
  type: EXPORT_RATINGS_ANALYTICS_SUCCESS
});

const exportRatingsAnalyticsFail = (format, message) => batchActions([
  exportingRatingsAnalytics(format, null),
  exportRatingsAnalyticsFailed(),
  displayErrorMessage(message)
]);

const exportRatingsAnalyticsFailed = () => ({
  type: EXPORT_RATINGS_ANALYTICS_FAILED
});

